var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10.68 8.52" }, props),
    React.createElement(
      "title",
      null,
      "slider_arrow_right"
    ),
    React.createElement("path", { d: "M7.2 4.11a.2.2 0 0 0 0-.24L4.38.3a.11.11 0 0 0-.19 0 .18.18 0 0 0 0 .24l2.59 3.28H.39a.17.17 0 0 0 0 .34h6.39L4.19 7.44a.18.18 0 0 0 0 .24.11.11 0 0 0 .19 0z", fill: "#eaf1f3" }),
    React.createElement("path", { d: "M7.2 4.11a.2.2 0 0 0 0-.24L4.38.3a.11.11 0 0 0-.19 0 .18.18 0 0 0 0 .24l2.59 3.28H.39a.17.17 0 0 0 0 .34h6.39L4.19 7.44a.18.18 0 0 0 0 .24.11.11 0 0 0 .19 0z", fill: "none", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: ".5" }),
    React.createElement("path", { fill: "none", stroke: "#fff", d: "M10.18.54v7.98" })
  );
});